import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { stopContainerApp } from '../apis';
import { toast } from 'react-toastify';

const useStopAppContainer = () => {
  const mutationData = useMutation({
    mutationFn: stopContainerApp,
    onSuccess: (data) => {
      toast.success('Run stop app container successfully');
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error run stop app container:', error);
    },
  });

  return mutationData;
};

export default useStopAppContainer;
